/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Upload_FileInputs */

const en_mobile_upload_file = /** @type {(inputs: Mobile_Upload_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload a file`)
};

const es_mobile_upload_file = /** @type {(inputs: Mobile_Upload_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir un archivo`)
};

/**
* | output |
* | --- |
* | "Upload a file" |
*
* @param {Mobile_Upload_FileInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_upload_file = /** @type {((inputs?: Mobile_Upload_FileInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Upload_FileInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_upload_file(inputs)
	return en_mobile_upload_file(inputs)
});